import { useTranslation } from "@/hooks/useTranslation"
import { WarningOutlined } from "@/icons"
import { TitleDrawer } from "@/molecules/TitleDrawer"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"
import { TitleDrawerRule } from "@/pages/GovernancePage/components/pages/AiPolicyPage/components/RuleCardList/TitleDrawerRule"

import styles from "../../AiPolicyViolationsDrawer.module.scss"

// "Violation of AI policy", with the policy's scope and name
export const TitleAiPolicyViolationsDrawer = ({
  record
}: {
  record?: { id: string }
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.violationLog"
  })
  const { findById, isPending } = useAiPolicies()
  const policy = record ? findById(record.id) : undefined

  return (
    <TitleDrawer
      noKaiButton
      loading={isPending}
      icon={<WarningOutlined />}
      classes={{ container: styles.titleContainer, icon: styles.titleIcon }}
      title={t("title")}
      subTitle={
        policy && policy.type !== "heading" ? (
          <TitleDrawerRule record={policy} />
        ) : undefined
      }
    />
  )
}
